import React from 'react';
import { Stack, Text } from '@fluentui/react';
import { StyledTag } from 'components/shared';
import { OpinionCategoryLabels } from 'services';
import { isEmptyObject } from 'components/util';

interface CaseFeedbackEntryHeaderProps {
  userType: string;
  labels: OpinionCategoryLabels;
}

function getTraits(opinionCategoryLabels: OpinionCategoryLabels): JSX.Element[] | JSX.Element {
  if (!isEmptyObject(opinionCategoryLabels)) {
    const result: JSX.Element[] = [];
    Object.keys(opinionCategoryLabels).forEach(key => {
      opinionCategoryLabels[key] &&
        opinionCategoryLabels[key].forEach(label => {
          result.push(<StyledTag className="mr-1" key={label} tag={label} />);
        });
    });
    return result;
  } else {
    return <Text variant="medium">None</Text>;
  }
}

export const CaseFeedbackEntryHeader: React.FunctionComponent<CaseFeedbackEntryHeaderProps> = props => {
  return (
    <Stack horizontal horizontalAlign="start" verticalAlign="center">
      <Stack.Item>
        <span className="font-weight-bold">Traits:</span>
        <div className="mb-3">{getTraits(props.labels)}</div>
      </Stack.Item>
    </Stack>
  );
};

export default CaseFeedbackEntryHeader;
